import React__default from 'react';
import Typography from '../Atoms/Typography.js';
import LazyImage from '../Atoms/LazyImage.js';

function HeroTwo(_a) {
    var title = _a.title, subTitle = _a.subTitle, backgroundImage = _a.backgroundImage, locationSearch = _a.locationSearch, logo = _a.logo, imageComponent = _a.imageComponent;
    var linearGradient = "linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4))";
    return (React__default.createElement("div", { className: "hero_parent" },
        React__default.createElement("div", { className: "hero_clipPath", style: {
                backgroundImage: "".concat(linearGradient, ", url(").concat(backgroundImage, ")")
            } },
            React__default.createElement("div", { className: "hero_clipPath__inner" })),
        React__default.createElement("div", { className: "hero" },
            React__default.createElement("div", { className: "hero__left" },
                logo ? (React__default.createElement(LazyImage, { src: logo, alt: "hero-logo", classes: "hero-two__logo", imageComponent: imageComponent })) : null,
                React__default.createElement("div", { className: "hero__title" },
                    React__default.createElement(Typography, { variant: "headingOne" }, title)),
                React__default.createElement("div", { className: "hero__sub_title" },
                    React__default.createElement(Typography, { variant: "headingTwo" }, subTitle)),
                locationSearch ? (React__default.createElement("div", { className: "hero__search" }, locationSearch)) : null),
            React__default.createElement("div", { className: "hero__right" }))));
}

export { HeroTwo as default };
//# sourceMappingURL=HeroTwo.js.map
